import { FunctionComponent, useMemo } from "react";
import VestingContext, { VestingContextValue } from "contexts/VestingContext";
import useConnectedAccount from "hooks/useConnectedAccount";
import useVestingAmountRemaining from "hooks/useVestingAmountRemaining";

const VestingProvider: FunctionComponent = ({ children }) => {
  const [address] = useConnectedAccount();

  const [
    vestingAmountInBearsRemaining,
    vestingAmountInBearsRemainingSum,
    readVestingAmountRemainingInBears,
  ] = useVestingAmountRemaining(
    "getVestingAmountRemainingInBearsByWallet",
    address
  );

  const [
    vestingAmountInJarsRemaining,
    vestingAmountInJarsRemainingSum,
    readVestingAmountRemainingInJars,
  ] = useVestingAmountRemaining(
    "getVestingAmountRemainingInJarsByWallet",
    address
  );

  const vestingAmountRemaining = useMemo(
    () =>
      vestingAmountInBearsRemainingSum &&
      vestingAmountInJarsRemainingSum &&
      vestingAmountInBearsRemainingSum.add(vestingAmountInJarsRemainingSum),
    [vestingAmountInBearsRemainingSum, vestingAmountInJarsRemainingSum]
  );

  const contextValue = useMemo<VestingContextValue>(
    () => ({
      vestingAmountInBearsRemaining,
      vestingAmountInBearsRemainingSum,
      readVestingAmountRemainingInBears,
      vestingAmountInJarsRemaining,
      vestingAmountInJarsRemainingSum,
      readVestingAmountRemainingInJars,
      vestingAmountRemaining,
    }),
    [
      vestingAmountInBearsRemaining,
      vestingAmountInBearsRemainingSum,
      readVestingAmountRemainingInBears,
      vestingAmountInJarsRemaining,
      vestingAmountInJarsRemainingSum,
      readVestingAmountRemainingInJars,
      vestingAmountRemaining,
    ]
  );

  return (
    <VestingContext.Provider value={contextValue}>
      {children}
    </VestingContext.Provider>
  );
};

export default VestingProvider;
